import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { CollectionSeal } from "@/components/livingLegacy/CollectionSeal";
import {
  COLLECTION_ROUTE,
  COLLECTION_TAGLINE,
  COLLECTION_TITLE,
  CHAPTERS,
  getPublishedChapters,
} from "@/lib/livingLegacy";
import mountLiamuiga from "@/assets/blog/mount-liamuiga-hike.jpg.asset.json";

/**
 * Homepage editorial card announcing The Living Legacy of Liamuiga collection.
 * Auto-updates its chapter count as new chapters are published in the registry.
 */
const LivingLegacyCard = () => {
  const published = getPublishedChapters().length;
  const total = CHAPTERS.length;

  return (
    <section className="relative overflow-hidden bg-[hsl(150_35%_8%)] py-24 md:py-32 text-[hsl(40_35%_94%)]">
      <div
        className="absolute inset-0 opacity-40"
        style={{
          backgroundImage: `url(${mountLiamuiga.url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[hsl(150_35%_8%)]/85 via-[hsl(150_35%_8%)]/75 to-[hsl(150_35%_8%)]/95" />
      <div className="pointer-events-none absolute inset-0 opacity-30 mix-blend-screen">
        <div
          className="absolute inset-0"
          style={{
            background:
              "radial-gradient(ellipse at 30% 40%, rgba(255,255,255,0.2) 0%, transparent 55%)",
            filter: "blur(40px)",
          }}
        />
      </div>

      <div className="container relative z-10 mx-auto max-w-4xl px-6 text-center">
        <Reveal>
          <CollectionSeal className="mx-auto mb-8 h-16 w-16" />
          <p className="font-sans text-[10px] tracking-[0.5em] uppercase text-[hsl(38_65%_70%)] mb-6">
            A Caribbean Heritage Collection
          </p>
          <h2 className="font-serif italic text-4xl md:text-6xl leading-[1.05] mb-8">
            {COLLECTION_TITLE}
          </h2>
          <p className="mx-auto max-w-2xl font-serif text-lg md:text-xl leading-[1.85] text-[hsl(40_30%_88%)]/90 mb-10">
            {COLLECTION_TAGLINE}
          </p>
          <p className="font-sans text-[10px] tracking-[0.35em] uppercase text-[hsl(38_65%_72%)]/80 mb-8">
            Chapter {published} of {total} · New chapters coming
          </p>
          <Link
            to={COLLECTION_ROUTE}
            className="group inline-flex items-center gap-3 border border-[hsl(38_65%_55%/0.5)] px-8 py-4 font-sans text-[11px] tracking-[0.4em] uppercase text-[hsl(38_65%_72%)] transition-colors hover:border-[hsl(38_65%_65%)] hover:text-[hsl(40_35%_96%)]"
          >
            Begin the Journey
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default LivingLegacyCard;
